<template>
    <div class="dialog">
        <el-dialog title="驳回原因" :visible.sync="visible" :lock-scroll="true" width="600px" :before-close="handleClose">
            <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left" label-width="140px">
                <el-row class="reject-c">
                    <el-input v-model="formTool.remarks" type="textarea" clearable size="small" style="width:100%" />
                </el-row>
            </el-form>
            <div class="btnBox">
                <el-button size="small" @click="handleClose">取消</el-button>
                <el-button type="primary" size="small" @click="reject">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import {
    salesAreaSysAudit,
} from "@/api/externalSalesRule";

export default {
    components: {

    },
    props: {
        btnType: {
            type: String,
            default: ''
        },
    },
    computed: {
        visible() {
            return this.dialogShow
        }
    },
    data() {
        return {
            showForm: false, //是否展示表单
            dialogShow: false,
            isDisabled: false,
            pageType: '',
            formTool: { remarks: '' },
            title: '',
        }
    },
    mounted() {

    },
    methods: {
        init(row, type) {
            this.dialogShow = true;
            this.id = row.id;
            this.$forceUpdate();
        },
        reject() {
            if (!this.formTool.remarks) {
                this.$message.error('请填写驳回原因！');
                return;
            }
            let params = {
                id: this.id,
                status: 2,
                remark: this.formTool.remarks
            }
            salesAreaSysAudit(params).then((res) => {
                if (res) {
                    this.$message.success('提交成功');
                    this.$emit('getList');
                    this.handleClose();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        handleClose() {
            this.dialogShow = false;
            this.formTool.remarks = "";
        },

    }
}
</script>
<style lang="scss">
.btnBox {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.serach {
    margin-bottom: 10px;
}

.goods-content {
    max-height: 70vh;
    overflow-y: auto;
}

.goodList {
    display: flex;
    justify-content: space-around;

    &:nth-child(3n) {
        margin-right: 0px;
    }

    .img-div {
        height: 88px;
        width: 88px;
        margin: 0 10px;

        image {
            width: 100%;
            height: 100%;
        }
    }

    .l {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
    }

    .r {
        width: 214px;
        display: flex;
        flex: 1;
        flex-direction: column;

        div {
            display: flex;
        }

        span {
            font-size: 13px;
            color: #333;
            //margin-top: 10px;
        }

        .name {
            text-align: left;
            font-size: 16px;
            font-weight: 600;
            color: var(--color-26);
        }

        .rr {
            text-align: left;
            color: var(--color-59);
            font-size: 14px;
        }
    }

    &:hover {
        //  border: 2px solid var(--main-color) !important;
    }
}

.reject-c {
    margin-top: 10px;

    .title {
        line-height: 30px;
    }
}
</style>